// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainDiv {
  margin: 20px;
}

.GeneratedDateText {
  color: white;
  padding: 0;
  margin: 0;
}

.ProjectNameText {
  text-align: center;
  color: white;
  font-size: 25px;
  font-weight: 500;
  padding: 0;
  margin: 0;
}

.ProjectDetailDiv {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.ProjectDetalText {
  color: white;
  padding: 10px;
}

.ProjectSummary {
  display: flex;
  flex-direction: row;
  background-color: #b6dde8;
  align-items: center;
  height: 80px;
  padding-left: 2px;
}

.SummaryHeading {
  color: black;
  font-weight: 500;
  font-size: 18px;
}

.SummaryDetailText {
  color: black;
  padding-left: 10px;
  font-size: 18px;
}

@media screen and (max-width: 768px) {
  .ProjectSummary {
    display: flex;
    flex-direction: column;
    background-color: rgb(95, 158, 160);
    align-items: center;
    justify-content: center;
    height: auto;
    padding-left: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/project/components/dark_version/ProjectDetails/MainComponentStyle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mCAAmC;IACnC,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".MainDiv {\n  margin: 20px;\n}\n\n.GeneratedDateText {\n  color: white;\n  padding: 0;\n  margin: 0;\n}\n\n.ProjectNameText {\n  text-align: center;\n  color: white;\n  font-size: 25px;\n  font-weight: 500;\n  padding: 0;\n  margin: 0;\n}\n\n.ProjectDetailDiv {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.ProjectDetalText {\n  color: white;\n  padding: 10px;\n}\n\n.ProjectSummary {\n  display: flex;\n  flex-direction: row;\n  background-color: #b6dde8;\n  align-items: center;\n  height: 80px;\n  padding-left: 2px;\n}\n\n.SummaryHeading {\n  color: black;\n  font-weight: 500;\n  font-size: 18px;\n}\n\n.SummaryDetailText {\n  color: black;\n  padding-left: 10px;\n  font-size: 18px;\n}\n\n@media screen and (max-width: 768px) {\n  .ProjectSummary {\n    display: flex;\n    flex-direction: column;\n    background-color: rgb(95, 158, 160);\n    align-items: center;\n    justify-content: center;\n    height: auto;\n    padding-left: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
